import { Box } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { GlobalContext } from "../../context/globalContext";
import { IAPI_ACC001_Response, IAPI_ACC012_Response } from "../../type/apiType";
import { API_ACC001, httpAPI_ACC010, httpAPI_ACC012 } from "./api/request";
import { schema, tableList } from "./parts";
import _ from "lodash";

/**
 * SCRW100005 アカウント情報更新
 * 機構職員が機構職員アカウントを更新する。
 * @return SCRW100005
 */
const SCRW100005 = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const [stateTableList, setStateTableList] = useState(_.cloneDeep(tableList));
  const [httpReq, setHttpReq] = useState<any>({});
  const [submitType, setSubmitType] = useState<"更新" | "削除">("更新");
  const [open, setOpen] = useState(false);
  const userIdRef = useRef();

  const callApiInit = async () => {
    // 機構ユーザ参照API実行
    try {
      const res = await httpAPI_ACC010({
        userId: location?.state?.userId,
      });

      if (res.resultCd === "I0000") {
        let tableArr = stateTableList;

        // 初期表示
        for (let i in res) {
          let targetObj = tableArr.find((item) => item.keyword === i)!;
          targetObj && (targetObj.text = res[i as keyof typeof res]);
        }

        setStateTableList([...tableArr]);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    callApiInit();
    if (location?.state?.userId) userIdRef.current = location?.state?.userId;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (data: any, index: any) => {
    if (index === 0 && data.password !== data.passwordConfirm) {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0078E",
      });
      return;
    }
    setHttpReq(data);
    setSubmitType(index === 0 ? "更新" : "削除");
    setOpen(true);
  };

  const handleCallApi = async (type: "更新" | "削除") => {
    setOpen(false);
    try {
      let res: IAPI_ACC012_Response | IAPI_ACC001_Response;
      const userId = userIdRef.current;
      if (type === "更新") {
        // 機構ユーザ更新API実行
        res = await httpAPI_ACC012({
          userId,
          password: httpReq.password,
        });
      } else {
        // ユーザアカウント失効化API実行
        res = await API_ACC001({ userId });
      }

      if (res.resultCd === "I0000") {
        navigate("/SCRW100003");
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box data-testid="SCRW100005PageForTest">
      <TkFakeTable
        list={stateTableList}
        ruleSchema={schema}
        buttonGroup={<TkBackButton />}
        submitButtonGroup={[
          { submitButtonText: "更新" },
          { submitButtonText: "削除", bypassValidation: true },
        ]}
        onCheckAndSubmit={handleSubmit}
      />

      <TkMessageDialog
        open={open}
        onOky={() => handleCallApi(submitType)}
        onCancel={() => setOpen(false)}
        title={`確認（アカウントを${submitType}します）`}
        contextText={`　${submitType}を行いますが、問題ないでしょうか。`}
        cancelText="いいえ"
        okText="はい"
      />
    </Box>
  );
};

export default SCRW100005;
